import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AgendaGradeLinha } from '../../../../interfaces/agenda';
import { AgendaModaisService } from '../../../../services/agenda/agenda-modais.service';
import { AgendaService, mensagemErroAgenda } from '../../../../services/agenda/agenda.service';

/** Reservar um horário livre ou liberar um reservado (só supervisão; o back relê o perfil). */
@Component({
  selector: 'app-agenda-reserva',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './agenda-reserva.component.html',
  styleUrl: './agenda-reserva.component.scss',
})
export class AgendaReservaComponent implements OnInit, OnDestroy {
  @Input({ required: true }) linha!: AgendaGradeLinha;

  @Output() fechar = new EventEmitter<void>();
  @Output() salvo = new EventEmitter<string>();

  salvando = false;
  erro = '';
  private fecharRegistro: (() => void) | null = null;

  constructor(private api: AgendaService, private modais: AgendaModaisService) {}

  ngOnInit() {
    this.fecharRegistro = this.modais.abrir();
  }

  ngOnDestroy() {
    this.fecharRegistro?.();
    this.fecharRegistro = null;
  }

  @HostListener('document:keydown.escape')
  aoEsc() {
    if (!this.modais.coberto()) this.cancelar();
  }

  cancelar() {
    if (!this.salvando) this.fechar.emit();
  }

  get liberar(): boolean { return this.linha.ieStatusAgenda === 'R'; }

  get dataBr(): string {
    const [a, m, d] = (this.linha.dtAgenda ?? '').slice(0, 10).split('-');
    return d ? `${d}/${m}/${a}` : '';
  }

  async confirmar() {
    if (this.salvando) return;
    this.salvando = true;
    this.erro = '';
    try {
      const req = { nrSequencia: this.linha.nrSequencia, tipo: this.linha.tipo === 'EXAME' ? 'EXAME' : 'CONSULTA' };
      const r = this.liberar ? await this.api.liberarReserva(req) : await this.api.reservarHorario(req);
      this.salvo.emit(r.mensagem || (this.liberar ? `Horário ${this.linha.hrInicio} liberado.` : `Horário ${this.linha.hrInicio} reservado.`));
    } catch (e) {
      this.erro = mensagemErroAgenda(e, this.liberar ? 'Erro ao liberar a reserva.' : 'Erro ao reservar o horário.');
    } finally {
      this.salvando = false;
    }
  }
}
